interface Auth0 {
	getAccessTokenSilently?: any;
}
const auth: Auth0 = {};
export default auth;
